import React from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import ContactForm from "../../components/ContactForm/ContactForm";
import insta from "../../images/insta.svg";
import twitter from "../../images/twitter.svg";
import fb from "../../images/fb.svg";
import li from "../../images/li.svg";
function ContactUs() {
  const navigate = useNavigate();
  React.useEffect(() => {
    window.scrollTo(0, 0)
  },[])
  return (
    <div className="bg-[#F7F9FB] pb-28 app">
      {" "}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact Us</title>
      </Helmet>
      <div onClick={() => navigate(-1)}>
        <svg
          className="p-4"
          width="151"
          height="17"
          viewBox="0 0 151 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.494 14V4.2H26.19C27.2073 4.2 27.9773 4.438 28.5 4.914C29.0227 5.39 29.284 5.98733 29.284 6.706C29.284 7.33133 29.116 7.83067 28.78 8.204C28.444 8.568 28.038 8.81533 27.562 8.946C27.9353 9.02067 28.2667 9.17 28.556 9.394C28.8547 9.618 29.088 9.898 29.256 10.234C29.424 10.57 29.508 10.934 29.508 11.326C29.508 11.83 29.382 12.2873 29.13 12.698C28.8873 13.0993 28.528 13.4167 28.052 13.65C27.576 13.8833 26.9927 14 26.302 14H22.494ZM23.978 8.4H26.008C26.5773 8.4 27.0113 8.26933 27.31 8.008C27.6087 7.73733 27.758 7.36867 27.758 6.902C27.758 6.44467 27.6087 6.08067 27.31 5.81C27.0207 5.53933 26.5773 5.404 25.98 5.404H23.978V8.4ZM23.978 12.782H26.106C26.7033 12.782 27.1653 12.642 27.492 12.362C27.828 12.082 27.996 11.69 27.996 11.186C27.996 10.682 27.8233 10.2853 27.478 9.996C27.1327 9.69733 26.666 9.548 26.078 9.548H23.978V12.782ZM33.4306 14.168C32.8426 14.168 32.3573 14.07 31.9746 13.874C31.592 13.678 31.3073 13.4213 31.1206 13.104C30.934 12.7773 30.8406 12.4227 30.8406 12.04C30.8406 11.368 31.102 10.836 31.6246 10.444C32.1473 10.052 32.894 9.856 33.8646 9.856H35.6846V9.73C35.6846 9.18867 35.5353 8.78267 35.2366 8.512C34.9473 8.24133 34.5693 8.106 34.1026 8.106C33.692 8.106 33.3326 8.20867 33.0246 8.414C32.726 8.61 32.544 8.904 32.4786 9.296H30.9946C31.0413 8.792 31.2093 8.36267 31.4986 8.008C31.7973 7.644 32.1706 7.36867 32.6186 7.182C33.076 6.986 33.5753 6.888 34.1166 6.888C35.0873 6.888 35.8386 7.14467 36.3706 7.658C36.9026 8.162 37.1686 8.85267 37.1686 9.73V14H35.8806L35.7546 12.81C35.5586 13.1927 35.274 13.5147 34.9006 13.776C34.5273 14.0373 34.0373 14.168 33.4306 14.168ZM33.7246 12.964C34.126 12.964 34.462 12.8707 34.7326 12.684C35.0126 12.488 35.2273 12.2313 35.3766 11.914C35.5353 11.5967 35.6333 11.2467 35.6706 10.864H34.0186C33.4306 10.864 33.0106 10.9667 32.7586 11.172C32.516 11.3773 32.3946 11.634 32.3946 11.942C32.3946 12.2593 32.5113 12.5113 32.7446 12.698C32.9873 12.8753 33.314 12.964 33.7246 12.964ZM42.1889 14.168C41.5076 14.168 40.8963 14.014 40.3549 13.706C39.8229 13.398 39.4029 12.9733 39.0949 12.432C38.7963 11.8813 38.6469 11.2467 38.6469 10.528C38.6469 9.80933 38.7963 9.17933 39.0949 8.638C39.4029 8.08733 39.8229 7.658 40.3549 7.35C40.8963 7.042 41.5076 6.888 42.1889 6.888C43.0476 6.888 43.7663 7.112 44.3449 7.56C44.9329 8.008 45.3109 8.61467 45.4789 9.38H43.9249C43.8316 8.99733 43.6263 8.69867 43.3089 8.484C42.9916 8.26933 42.6183 8.162 42.1889 8.162C41.8249 8.162 41.4889 8.25533 41.1809 8.442C40.8729 8.61933 40.6256 8.88533 40.4389 9.24C40.2523 9.58533 40.1589 10.0147 40.1589 10.528C40.1589 11.0413 40.2523 11.4753 40.4389 11.83C40.6256 12.1753 40.8729 12.4413 41.1809 12.628C41.4889 12.8147 41.8249 12.908 42.1889 12.908C42.6183 12.908 42.9916 12.8007 43.3089 12.586C43.6263 12.3713 43.8316 12.068 43.9249 11.676H45.4789C45.3203 12.4227 44.9469 13.0247 44.3589 13.482C43.7709 13.9393 43.0476 14.168 42.1889 14.168ZM47.0884 14V3.92H48.5724V9.926L51.2324 7.056H53.0104L50.0564 10.206L53.4444 14H51.5684L48.5724 10.444V14H47.0884Z"
            fill="#2F69FF"
          />
          <path
            d="M0.646447 9.64644C0.451184 9.8417 0.451184 10.1583 0.646446 10.3535L3.82842 13.5355C4.02369 13.7308 4.34027 13.7308 4.53553 13.5355C4.73079 13.3403 4.73079 13.0237 4.53553 12.8284L1.70711 9.99999L4.53554 7.17157C4.7308 6.97631 4.7308 6.65972 4.53554 6.46446C4.34028 6.2692 4.02369 6.2692 3.82843 6.46446L0.646447 9.64644ZM11.5 9.5L1 9.49999L1 10.5L11.5 10.5L11.5 9.5Z"
            fill="#2F69FF"
          />
        </svg>
      </div>
      <p className="text-center sell py-4 ">Contact Us</p>
      <div className="px-4 flex gap-x-12 mt-12 mobile:flex-row flex-col gap-y-6 justify-between">
        <div className="w-full">
          <p className="text-zinc-900 text-xl mb-6 font-bold">Rise an enquiry</p>
          <ContactForm/>
        </div>
        <div className="w-full">
          <p className="text-zinc-900 text-xl font-bold mb-6">Contact with Us</p>
          <div className='shadow-lg p-5 bg-white'>
            <div className='flex flex-row'>



          <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
              d="M17.8044 12.4561C17.6922 12.3436 17.5588 12.2544 17.412 12.1935C17.2652 12.1327 17.1078 12.1013 16.9489 12.1013C16.7899 12.1013 16.6325 12.1327 16.4857 12.1935C16.3389 12.2544 16.2055 12.3436 16.0933 12.4561L14.1642 14.3851C13.2699 14.1188 11.6011 13.5138 10.5434 12.4561C9.48566 11.3985 8.88057 9.7297 8.61433 8.83541L10.5434 6.90646C10.6558 6.79418 10.7451 6.66082 10.806 6.51401C10.8668 6.3672 10.8982 6.20983 10.8982 6.0509C10.8982 5.89197 10.8668 5.7346 10.806 5.58779C10.7451 5.44098 10.6558 5.30762 10.5434 5.19534L5.70264 0.354812C5.59035 0.242335 5.45698 0.153103 5.31017 0.0922202C5.16335 0.0313377 5.00598 0 4.84704 0C4.6881 0 4.53072 0.0313377 4.38391 0.0922202C4.2371 0.153103 4.10373 0.242335 3.99144 0.354812L0.709428 3.63669C0.24956 4.09654 -0.00941939 4.72823 0.000262058 5.37323C0.0280962 7.09645 0.484335 13.0818 5.20162 17.7989C9.91891 22.5159 15.9045 22.971 17.629 23H17.6629C18.3018 23 18.9057 22.7483 19.3632 22.2909L22.6452 19.009C22.7577 18.8967 22.8469 18.7633 22.9078 18.6165C22.9687 18.4697 23 18.3124 23 18.1534C23 17.9945 22.9687 17.8371 22.9078 17.6903C22.8469 17.5435 22.7577 17.4101 22.6452 17.2979L17.8044 12.4561ZM17.6508 20.5785C16.1404 20.5531 10.973 20.1477 6.91282 16.0865C2.83935 12.0132 2.44483 6.8278 2.42062 5.34781L4.84704 2.9215L7.97657 6.0509L6.4118 7.6156C6.26956 7.75773 6.16498 7.93306 6.10751 8.12575C6.05003 8.31844 6.04149 8.52242 6.08263 8.71924C6.11168 8.85841 6.82205 12.1584 8.83095 14.1673C10.8399 16.1761 14.14 16.8864 14.2792 16.9155C14.4759 16.9578 14.6801 16.9499 14.873 16.8926C15.0658 16.8353 15.2412 16.7304 15.3829 16.5875L16.9489 15.0228L20.0784 18.1522L17.6508 20.5785Z"
              fill="url(#paint0_linear_747_38467)"
              />
            <defs>
              <linearGradient
                id="paint0_linear_747_38467"
                x1="21.7895"
                y1="23"
                x2="-3.42826"
                y2="11.4167"
                gradientUnits="userSpaceOnUse"
                >
                <stop stop-color="#383838" />
                <stop offset="1" stop-color="#8264F9" />
              </linearGradient>
            </defs>
          </svg>
          <p className="ml-5">96584-42317</p>
                  </div>
                  <div className='flex flex-row my-5'>

          <svg
            width="24"
            height="18"
            viewBox="0 0 24 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
              d="M2.09077 4.04891V17.7066H0.351562V0.660156L0.674133 0.865557L11.1516 7.99512C11.2742 8.09385 11.4246 8.14742 11.5794 8.14742C11.7341 8.14742 11.8845 8.09385 12.0071 7.99512L22.4706 0.880241L22.7931 0.660156V17.7066H21.068V4.12224L20.7593 4.31295C18.1786 6.05868 15.5978 7.80444 13.017 9.5795C12.603 9.90674 12.0983 10.0838 11.5794 10.0838C11.0604 10.0838 10.5557 9.90674 10.1417 9.5795C7.56089 7.80444 4.98017 6.05868 2.39939 4.31295L2.09077 4.04891Z"
              fill="url(#paint0_linear_747_38475)"
              stroke="url(#paint1_linear_747_38475)"
              stroke-width="0.5"
              stroke-miterlimit="10"
              />
            <defs>
              <linearGradient
                id="paint0_linear_747_38475"
                x1="21.612"
                y1="17.7066"
                x2="-0.206484"
                y2="4.51285"
                gradientUnits="userSpaceOnUse"
                >
                <stop stop-color="#383838" />
                <stop offset="1" stop-color="#8264F9" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_747_38475"
                x1="21.612"
                y1="17.7066"
                x2="-0.206484"
                y2="4.51285"
                gradientUnits="userSpaceOnUse"
                >
                <stop stop-color="#383838" />
                <stop offset="1" stop-color="#8264F9" />
              </linearGradient>
            </defs>
          </svg>
          <p className='ml-5'>Example@gmail.com</p>
                  </div>
          <div className="social flex gap-x-4 mt-5 ">
                            <a href="">
                                <img src={insta} width={36} height={36} />
                            </a>
                            <a href="">
                                <img src={twitter} width={36} height={36} />
                            </a>
                            <a href="">
                                <img src={fb} width={36} height={36} />
                            </a>
                            <a href="">
                                <img src={li} width={36} height={36} />
                            </a>
                        </div>
                  </div>
        </div>
      
      </div>
    </div>
  );
}

export default ContactUs;
